import { render } from "./AjaxForm.vue?vue&type=template&id=85e91302&scoped=true"
import script from "./AjaxForm.vue?vue&type=script&lang=js"
export * from "./AjaxForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e91302"]])

export default __exports__